import emitter from '../../../shared/mixin/emitter';

export default {
  name: 'UiFormCheckbox',

  mixins: [emitter],

  inheritAttrs: false,

  inject: {
    uiFormItem: {
      default: '',
    },
  },

  template: `
    <div :class="[
      'form-check',
      { 
        'form-check-inline': inline,
        'is-disabled': disabled,
        'is-checked': isChecked,
      }
    ]">
      <label class="form-check-label">
        <input
          v-if="trueLabel || falseLabel"
          class="form-check-input"
          type="checkbox"
          :name="name"
          :disabled="disabled"
          :true-value="trueLabel"
          :false-value="falseLabel"
          v-model="model"
          @change="handleChange" />
        <input 
          v-else
          class="form-check-input"
          type="checkbox"
          :name="name"
          :disabled="disabled"
          :value="label"
          v-model="model"
          @change="handleChange" />
        <slot></slot>
        <template v-if="!$slots.default">{{ label }}</template>
      </label>
    </div>
  `,

  props: {
    value: {},
    label: {},
    disabled: Boolean,
    checked: Boolean,
    name: Boolean,
    trueLabel: [String, Number],
    falseLabel: [String, Number],
    inline: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      selfModel: false,
    };
  },

  computed: {
    model: {
      get() {
        return this.value !== undefined ? this.value : this.selfModel;
      },
      set(val) {
        this.$emit('input', val);
        this.selfModel = val;
      },
    },

    isChecked() {
      if ({}.toString.call(this.model) === '[object Boolean]') {
        return this.model;
      } else if (Array.isArray(this.model)) {
        return this.model.indexOf(this.label) > -1;
      } else if (this.model !== null && this.model !== undefined) {
        return this.model === this.trueLabel;
      }
    },
  },

  watch: {
    value(value) {
      this.dispatch('UiFormItem', 'ui.form.change', value);
    },
  },

  methods: {
    addToStore() {
      if (Array.isArray(this.model) && this.model.indexOf(this.label) === -1) {
        this.model.push(this.label);
      } else {
        this.model = this.trueLabel || true;
      }
    },

    handleChange(ev) {
      let value;
      if (ev.target.checked) {
        value = this.trueLabel === undefined ? true : this.trueLabel;
      } else {
        value = this.falseLabel === undefined ? false : this.falseLabel;
      }
      this.$emit('change', value, ev);
    },

    handleBlur(ev) {
      this.$emit('blur', ev);
      this.dispatch('UiFormItem', 'ui.form.blur', [this.currentValue]);
    },
  },

  created() {
    if (this.checked) {
      this.addToStore();
    }
  },
};
